<template>
  <div>
    <v-chip :color="cor" :dark="!textoEscuro" small label>{{ rotulo }}</v-chip>
  </div>
</template>

<script>
export const CORES_RISCO = {
  atencao: "amber darken-1",
  alto_risco: "orange darken-3",
  critico: "red darken-3",
};

export const temTextoEscuro = (categoria) => categoria === "atencao";

const ROTULOS = {
  atencao: "Atenção",
  alto_risco: "Alto Risco",
  critico: "Crítico",
};

export default {
  name: "EChipRiscoEvasao",
  props: {
    categoria: { type: String, default: null },
    categoriaRotulo: { type: String, default: null },
    status: { type: String, default: null },
  },
  computed: {
    encerrado() {
      return this.status === "encerrado";
    },
    cor() {
      if (this.encerrado) return "blue-grey";
      return CORES_RISCO[this.categoria] ?? "grey";
    },
    textoEscuro() {
      return !this.encerrado && temTextoEscuro(this.categoria);
    },
    rotulo() {
      if (this.encerrado) return "Acompanhamento Encerrado";
      return this.categoriaRotulo ?? ROTULOS[this.categoria] ?? "- - -";
    },
  },
};
</script>
